class ImageSlider {
  constructor(wrapper) {
    this.wrapper = wrapper;
    this.track = wrapper.querySelector('[data-slider-track]');
    this.slides = Array.from(wrapper.querySelectorAll('[data-slide]'));
    this.dots = Array.from(wrapper.querySelectorAll('[data-slider-dot]'));
    this.prevBtn = wrapper.querySelector('[data-slider-prev]');
    this.nextBtn = wrapper.querySelector('[data-slider-next]');

    this.autoplay = wrapper.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(wrapper.dataset.autoplaySpeed, 10) || 5000;

    this.current = 0;
    this.timer = null;

    if (this.slides.length === 0) return;

    this.bindEvents();
    this.goTo(0);
    if (this.autoplay && this.slides.length > 1) this.startAutoplay();
  }

  bindEvents() {
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => {
        this.goTo(this.current - 1);
        this.restartAutoplay();
      });
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => {
        this.goTo(this.current + 1);
        this.restartAutoplay();
      });
    }
    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        this.goTo(parseInt(dot.dataset.index, 10));
        this.restartAutoplay();
      });
    });

    // Pause on hover / focus for accessibility
    this.wrapper.addEventListener('mouseenter', () => this.stopAutoplay());
    this.wrapper.addEventListener('mouseleave', () => {
      if (this.autoplay) this.startAutoplay();
    });

    // Basic touch swipe support
    let startX = 0;
    this.track.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
    }, { passive: true });
    this.track.addEventListener('touchend', (e) => {
      const diff = e.changedTouches[0].clientX - startX;
      if (Math.abs(diff) > 40) {
        diff > 0 ? this.goTo(this.current - 1) : this.goTo(this.current + 1);
        this.restartAutoplay();
      }
    }, { passive: true });
  }

  goTo(index) {
    const total = this.slides.length;
    const newIndex = (index + total) % total;

    this.slides.forEach((slide, i) => {
      slide.classList.remove('is-active', 'is-prev');
      if (i === newIndex) slide.classList.add('is-active');
      if (i === this.current && i !== newIndex) slide.classList.add('is-prev');
    });

    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === newIndex);
    });

    this.current = newIndex;
  }

  startAutoplay() {
    this.stopAutoplay();
    this.timer = setInterval(() => this.goTo(this.current + 1), this.autoplaySpeed);
  }

  stopAutoplay() {
    if (this.timer) clearInterval(this.timer);
    this.timer = null;
  }

  restartAutoplay() {
    if (this.autoplay) this.startAutoplay();
  }

  destroy() {
    this.stopAutoplay();
  }
}

function initSliders(context = document) {
  context.querySelectorAll('[data-slider]').forEach((wrapper) => {
    if (wrapper.sliderInstance) return;
    wrapper.sliderInstance = new ImageSlider(wrapper);
  });
}

document.addEventListener('DOMContentLoaded', () => initSliders());

// Theme editor support: re-init on section load, pause during editing
document.addEventListener('shopify:section:load', (event) => {
  initSliders(event.target);
});

document.addEventListener('shopify:section:select', (event) => {
  const wrapper = event.target.querySelector('[data-slider]');
  if (wrapper && wrapper.sliderInstance) wrapper.sliderInstance.stopAutoplay();
});

document.addEventListener('shopify:block:select', (event) => {
  const slide = event.target;
  const wrapper = slide.closest('[data-slider]');
  if (wrapper && wrapper.sliderInstance) {
    const index = parseInt(slide.dataset.index, 10);
    wrapper.sliderInstance.stopAutoplay();
    wrapper.sliderInstance.goTo(index);
  }
});

document.addEventListener('shopify:block:deselect', (event) => {
  const wrapper = event.target.closest('[data-slider]');
  if (wrapper && wrapper.sliderInstance && wrapper.sliderInstance.autoplay) {
    wrapper.sliderInstance.startAutoplay();
  }
});
